(() => {
  const bindDetails = (details) => {
    if (!details || details.dataset.zenitDetailsBound === 'true') return;

    const tabs = Array.from(details.querySelectorAll('[role="tab"]'));
    const panels = Array.from(details.querySelectorAll('[role="tabpanel"]'));
    if (tabs.length === 0 || panels.length === 0) return;

    details.dataset.zenitDetailsBound = 'true';

    const activate = (tab, moveFocus = false) => {
      const activePanelId = tab.getAttribute('aria-controls');

      tabs.forEach((candidate) => {
        const isActive = candidate === tab;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-selected', String(isActive));
        candidate.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.id === activePanelId;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.inert = !isActive;
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };

  const bindAll = (root = document) => {
    root.querySelectorAll('[data-zenit-product-details]').forEach(bindDetails);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
